module.exports = __webpack_public_path__ + "static/media/anchor.3076a001.jpg";